/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Actions for optimizely-middleware
 */

import type { EventTags, UserAttributes } from '@optimizely/optimizely-sdk'
import { createAction } from 'redux-actions'
import { ACTIVATE, TRACK } from './constants'

export interface TrackPayload {
  eventKey: string
  attributes?: UserAttributes | undefined
  tags?: EventTags | undefined
}

export interface ActivatePayload {
  experimentKey: string
}

export const track = createAction<TrackPayload, typeof TRACK>(TRACK)
export const activate = createAction<ActivatePayload, typeof ACTIVATE>(ACTIVATE)
